import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {MapContext} from "../../../../contexts/MapContext";

export default function MarkersMapper({
    markers, 
    MarkerComponent, 
    naturalSize, 
    onClick, 
    getAdditionalProps = () => ({}), 
    params = {}
}) {
    const navigate = useNavigate();
    const {zoomStyles} = useContext(MapContext);

    return (
        <svg
            viewBox={`0 0 ${naturalSize.width} ${naturalSize.height}`}
            style={zoomStyles}
        >
            {markers?.map((marker, index) => {
                // Ensure 'align' is 'right' if not explicitly specified
                const markerWithDefaultAlign = {
                    ...marker,
                    align: marker.align || "right",
                    ...getAdditionalProps(marker) // Apply additional props from the function
                };
                
                // Custom onClick handler that checks for bird value
                const handleClick = () => {
                    // If bird is null or empty string, don't allow clicking/navigation
                    if (markerWithDefaultAlign.bird === null || markerWithDefaultAlign.bird === "") {
                        return; // Do nothing for communities with null or empty bird
                    }
                    
                    // Otherwise use the normal click behavior
                    if (onClick) {
                        onClick(markerWithDefaultAlign);
                    } else if (markerWithDefaultAlign.path) {
                        navigate(markerWithDefaultAlign.path);
                    }
                };
                
                return (
                    <MarkerComponent
                        key={index}
                        onClick={handleClick}
                        {...markerWithDefaultAlign}
                        {...params}
                    />
                );
            })}
        </svg>
    )
}
